import c from './assets/sass/loader.module.scss'

export const Loader = ({ progress = 0 }) => {
    return (
        <div className={c.component}>
            <div
                className={c.line}
                style={{ width: `${progress}%`, transition: 'width 0.3s ease' }}
            />
        </div>
    )
}
